import { createSvgIcon } from "@mui/material";

export const PlacementTopLeftIcon = createSvgIcon(
  <svg viewBox="0 0 12 9" fill="none">
    <path
      fill="currentColor"
      d="M.001 7.599a.85.85 0 0 1 .844-.844h5.063c.474 0 .843.37.843.844a.85.85 0 0 1-.844.844H.845a.87.87 0 0 1-.844-.844M11.812.844a.85.85 0 0 1-.843.844H.844A.87.87 0 0 1 0 .844.85.85 0 0 1 .844 0h10.125c.474 0 .844.37.844.844M.002 4.219a.85.85 0 0 1 .843-.844h5.063c.474 0 .843.37.843.844a.85.85 0 0 1-.844.843H.845a.87.87 0 0 1-.844-.843"
    />
  </svg>,
  "PlacementTopLeftIcon",
);
